import { defaultFilterPermissions, defaultFilterRoles, defaultSelectedRol } from "./state";

/**
 * Mutación para listar los roles registrados.
 *
 * @export
 * @param {*} state
 * @param {*} roles
 */
export function setRoles(state, roles) {
    state.roles = roles;
} 

/**
 * Mutación para obtener los permisos del rol seleccionado.
 *
 * @export
 * @param {*} state
 * @param {*} permissions
 */
export function setPermissions(state, permissions) {
    permissions.data.forEach((permission) => {
        if (permission.roles.length) {
            permission.asignado = true;
        } else if (permission.usuario) {
            if (permission.usuario.length) {
                permission.asignado = true;
            }
        } else {
            permission.asignado = false;
        }
    })
    state.permissions = permissions;
}

/**
 * Mutación para determinar la vista del usuario.
 *
 * @export
 * @param {*} state
 * @param {*} view
 */
export function setView(state, view) {
    state.view = view;
}

/**
 * Mutación para obtener la información del rol seleccionado.
 *
 * @export
 * @param {*} state
 * @param {*} rol contiene la información del rol.
 */
export function setSelectedRol(state, rol) {
    Object.assign(state.selectedRol, rol)
}

/**
 * Mutación para resetear el rol seleccionado.
 *
 * @export
 * @param {*} state
 */
 export function resetSelectedRol(state) {
    Object.assign(state.selectedRol, defaultSelectedRol());
}

/**
 * Mutación para cambiar la página del buscador de roles.
 *
 * @export
 * @param {*} state
 * @param {*} page
 */
export function setPageRoles(state, page) {
    Object.assign(state.filterRoles, {page: page});
}

/**
 * Mutación para cambiar la cantidad de registros por página del buscador de roles.
 *
 * @export
 * @param {*} state
 * @param {*} page
 */
export function setPerPageRoles(state, perPage) {
    Object.assign(state.filterRoles, {perPage: perPage});
}

/**
 * Mutación para cambiar la cantidad de registros por página del buscador de permisos.
 *
 * @export
 * @param {*} state
 * @param {*} page
 */
 export function setPerPagePermissions(state, perPage) {
    Object.assign(state.filtersPermissions, {perPage: perPage});
}

/**
 * Mutación para cambiar la página del buscador de permisos.
 *
 * @export
 * @param {*} state
 * @param {*} page
 */
 export function setPagePermissions(state, page) {
    Object.assign(state.filtersPermissions, {page: page});
}

/**
 * Mutación para limpiar los filtros de búsqueda de roles.
 *
 * @export
 * @param {*} state
 */
export function resetFiltersRoles(state) {
    Object.assign(state.filterRoles, defaultFilterRoles());
}

/**
 * Mutación para limpiar los filtros de búsqueda de permisos.
 *
 * @export
 * @param {*} state
 */
 export function resetFiltersPermissions(state) {
    Object.assign(state.filtersPermissions, defaultFilterPermissions());
}